// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__mkLu7","header":"style_header__8HkKY","tv_show_details":"style_tv_show_details__ipaY-","recommandations":"style_recommandations__Flrzo"};